// extracted by mini-css-extract-plugin
module.exports = {"journeyContainer":"JourneyList_journeyContainer__1dDQr","nda":"JourneyList_nda__AF-K7"};